import type { PlatformInvitationCode } from '@/services/api/platform.service';
import { Badge } from '@/components/ui/badge';

const formatDateTime = (iso: string) => new Date(iso).toLocaleString();

/**
 * Validity of a code: the local state (active / expiry / cap) is live, the
 * Stripe coupon and plan price come from the last server-side check.
 */
export function InvitationCodeStatus({ code }: { code: PlatformInvitationCode }) {
  const problems = code.lastCheck?.problems ?? [];
  const warnings = code.lastCheck?.warnings ?? [];
  const unchecked = code.lastCheck === null;
  const valid = code.redeemable && !unchecked && code.lastCheck?.valid;

  return (
    <div className="space-y-1" data-testid={`status-${code.code}`}>
      {valid ? (
        <Badge tone="success">Valid</Badge>
      ) : unchecked ? (
        <Badge tone="neutral">Not checked</Badge>
      ) : (
        <Badge tone="danger">Invalid</Badge>
      )}
      {problems.length > 0 && (
        <ul className="list-disc pl-4 text-xs text-danger-text">
          {problems.map((problem) => <li key={problem}>{problem}</li>)}
        </ul>
      )}
      {warnings.length > 0 && (
        <ul className="list-disc pl-4 text-xs text-warn-text">
          {warnings.map((warning) => <li key={warning}>{warning}</li>)}
        </ul>
      )}
      {code.lastCheckedAt && (
        <p className="text-xs text-ink-subtle">Checked {formatDateTime(code.lastCheckedAt)}</p>
      )}
    </div>
  );
}
